export default [{
  path: '/iea',
  component: () => import('@/views/Index'),
  children: [
    { path: '', redirect: 'historico' },
    {
      name: 'AIE Histórico',
      path: 'historico',
      component: () => import('@/views/aie/Historico.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { name: 'Power Ups', path: '/powerups' },
          { name: 'IeA - Acompanhamento de Obras' }
        ]
      }
    },
    {
      name: 'AIE Importar',
      path: 'importar',
      component: () => import('@/views/aie/Importar.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { name: 'Power Ups', path: '/powerups' },
          { name: 'IeA - Acompanhamento de Obras', path: '/iea/historico?tab=importacoes' },
          { name: 'Importar Justificativas' }
        ]
      }
    },
    {
      name: 'AIE Adicionar',
      path: 'add',
      component: () => import('@/views/aie/Adicionar.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { name: 'Power Ups', path: '/powerups' },
          { name: 'IeA - Acompanhamento de Obras', path: '/iea/historico' },
          { name: 'Novo Relatório' }
        ]
      }
    },
    {
      name: 'AIE Adicionar Histórico',
      path: 'add-historico',
      component: () => import('@/views/aie/Adicionar.vue'),
      meta: {
        requiresAuth: true,
        tipo: 'HISTORICO_JUSTIFICATIVAS',
        breadcrumb: [
          { name: 'Power Ups', path: '/powerups' },
          { name: 'IeA - Acompanhamento de Obras', path: '/iea/historico' },
          { name: 'Novo Histórico de Justificativas' }
        ]
      }
    }
  ]
},
// Links e favoritos antigos da ferramenta, de quando ela se chamava AIE.
{
  path: '/aie/:caminho(.*)?',
  redirect: to => ({ path: `/iea/${to.params.caminho || ''}`, query: to.query })
}];
